import { create } from 'zustand'

interface MobileNavStore {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}

export const useMobileNav = create<MobileNavStore>((set) => ({
  isOpen: false,
  setIsOpen: (isOpen) => set({ isOpen }),
}))
